import { render, staticRenderFns } from "./CustomerDetailsPopover.vue?vue&type=template&id=fc625f18"
import script from "./CustomerDetailsPopover.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports